var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Receipt',{attrs:{"endpointurl":'/api/shippingpurchases/add',"show-prices":false,"show-paymentmethods":false,"show-pos":true,"show-choosedate":true,"show-totals":false,"config":_vm.config,"payment_methods":_vm.payments_methods,"branchofficeData":_vm.branchofficeData}})
}
var staticRenderFns = []

export { render, staticRenderFns }